import { ToastrService } from 'ngx-toastr';
import { ResetUserPasswordInput } from './../../../@resources/graphql/types/types';
import { AuthService } from './../../../@resources/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { REGEX } from 'src/app/@resources/validators/validator';
import { LocalStorageService } from '../../../@resources/services/local-storage.service';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.scss'],
})
export class ResetPasswordDialogComponent implements OnInit {
  resetForm: FormGroup = this.fb.group({
    password: ['', [Validators.required, Validators.pattern(REGEX.password)]],
    confirmPassword: [
      '',
      [Validators.required, Validators.pattern(REGEX.password)],
    ],
  });
  isSubmitting: boolean;
  constructor(
    public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    private fb: FormBuilder,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: { email: string; token: string },
    private localStorage: LocalStorageService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {}

  resetPassword() {
    const lang = this.localStorage.get('lang');
    this.isSubmitting = true;
    let obj: ResetUserPasswordInput = {
      email: this.data.email,
      token: this.data.token,
      password: this.resetForm.value.password,
    };
    this.authService.resetPassword(obj).subscribe(
      (res: any) => {
        if (res?.data?.resetPassword) {
          lang == 'en'
            ? this.toastrService.success(
                `${res?.data?.resetPassword?.message}`,
                `Reset Password`
              )
            : this.toastrService.success(
                `${res?.data?.resetPassword?.message}`,
                `اعادة تعيين كلمة السر`
              );
          this.dialogRef.close();
        }

        this.isSubmitting = false;
      },
      (error) => {
        this.isSubmitting = false;
      }
    );
  }

  public get password() {
    return this.resetForm.get('password');
  }

  public get confirmPassword() {
    return this.resetForm.get('confirmPassword');
  }
}
